import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentUser: null,
  userImage: null,
  userName: '',
  loading: false,
  error: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
    },
    loginSuccess: (state, action) => {
      state.loading = false;
      state.currentUser = action.payload;
    },
    loginFailure: (state) => {
      state.loading = false;
      state.error = true;
    },
    logOff: (state) => {
      state.currentUser = null;
      state.loading = false;
      state.error = false;
    },
    updateUserImage: (state, action) => {
      state.loading = false;
      state.userImage = action.payload;
    },
    updateUserName: (state, action) => {
      state.loading = false;
      state.userName = action.payload;
    }
  },
});

export const { loginStart, loginSuccess, loginFailure, logOff, updateUserImage, updateUserName } =
  userSlice.actions;

export default userSlice.reducer;